import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function toastNotify(msg: any, type: any) {

  const isDark = localStorage.getItem('darkmode');

  if (type === "success") {
    toast.success(msg, {
      position: "top-right",
      autoClose: 2000,
      theme: isDark ? 'dark' : "light"
    });
  } else if (type === "error")
    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      theme: isDark ? 'dark' : "light"
    });
}

export default toastNotify;
